import get from 'lodash/get'
import size from 'lodash/size'

// check that a collection is populated
export const hasLength = (array) => !!size(array)

// Status

const compareStatus = (path, value) => (state) => get(state, `${path}.status`) === value

export const status = (path, prefix = 'is') => ({
  [`${prefix}Failure`]: compareStatus(path, 'FAILURE'),
  [`${prefix}Pending`]: compareStatus(path, 'PENDING'),
  [`${prefix}Success`]: compareStatus(path, 'SUCCESS'),
})
